import { render } from "./TogglerSetting.vue?vue&type=template&id=665e9eea&lang=pug"
import script from "./TogglerSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./TogglerSetting.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__